
import { Component, Vue, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { PermissionModule } from '@/store/modules/permission'
import { SettingsModule } from '@/store/modules/settings'
import SidebarItem from './SidebarItem.vue'
import SidebarLogo from './SidebarLogo.vue'
import variables from '@/styles/_variables.scss'
import { getTaskCenter } from '@/api/admin'
import { getEnterprise } from '@/api/universal'

@Component({
  name: 'SideBar',
  components: {
    SidebarItem,
    SidebarLogo
  }
})
export default class extends Vue {
  private taskCenter: any = {}
  private timer: any = null

  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
    ? this.$store.state.app.enterprise.ssl_switch.site_logo
    : ''

  get language() {
    return AppModule.language
  }

  // 获取平台代付声效开关
  private notifySwitch: boolean = false
  private async getEnterpriseInfo() {
    try {
      await getEnterprise().then((res: any) => {
        this.notifySwitch = res.ssl_switch.payout_notify_switch
      })
    } catch (e) {}
  }

  @Watch('taskCenter', { deep: true })
  private onTaskCenter(newValue, oldValue) {
    let newCount = 0
    Object.keys(newValue).forEach((key: string) => {
      typeof newValue[key] === 'number' && (newCount += newValue[key])
    })
    let oldCount = 0
    Object.keys(oldValue).forEach((key: string) => {
      typeof oldValue[key] === 'number' && (oldCount += oldValue[key])
    })
    if (newCount > oldCount) {
      if (this.language === 'en') {
        this.$notify({
          title: 'New Task',
          message: 'New mission added! Please go for approval!',
          type: 'success',
          duration: 5000
        })
      } else if (this.language === 'zh_cn') {
        this.$notify({
          title: '新任务 ',
          message: '添加了新任务！请去审批！',
          type: 'success',
          duration: 5000
        })
      } else if (this.language === 'zh_tw') {
        this.$notify({
          title: '新任務 ',
          message: '添加了新任務！請去審批！',
          type: 'success',
          duration: 5000
        })
      }
    }

    if (newValue.withdraw_review_count > oldValue.withdraw_review_count) {
      if (this.language === 'en') {
        if (this.notifySwitch === true) {
          this.enHandleSpeak('You have a new task wait for review')
        }
      } else if (this.language === 'zh_cn' || this.language === 'zh_tw') {
        if (this.notifySwitch === true) {
          this.zhHandleSpeak('您有新的出金任务等待审查')
        }
      }
    }
  }

  // 退款订单计数提醒
  @Watch('taskCenter.refund_order_count', { deep: true })
  private refundOrder(newValue, oldValue) {
    if (newValue > oldValue) {
      if (this.language === 'en') {
        this.$notify({
          title: 'New Message',
          message: 'You have a new refund order, please check it',
          type: 'warning',
          duration: 5000
        })
      } else if (this.language === 'zh_cn') {
        this.$notify({
          title: '新提醒',
          message: '您有新的退款订单，请注意查看',
          type: 'warning',
          duration: 5000
        })
      }
    }
  }

  // 请求日志未读
  @Watch('taskCenter.api_log_count', { deep: true })
  private application(newValue, oldValue) {
    if (newValue > oldValue) {
      if (this.language === 'en') {
        this.$notify({
          title: 'New Message',
          message: 'You have a new application, please check it',
          type: 'warning',
          duration: 5000
        })
      } else {
        this.$notify({
          title: '新提醒',
          message: 'You have a new application, please check it',
          type: 'warning',
          duration: 5000
        })
      }
    }
  }

  private async getTaskCenter() {
    try {
      await getTaskCenter().then((res: any) => {
        this.taskCenter = res
        AppModule.SetTaskCenter(this.taskCenter)
      })
    } catch (e) {
      if (JSON.stringify(e).includes('status code 401')) {
        if (this.timer) {
          clearInterval(this.timer)
        }
      }
    }
  }

  private synth = window.speechSynthesis
  private msg = new SpeechSynthesisUtterance()
  // 英文语音
  private enHandleSpeak(text) {
    this.msg.text = text // 文字内容
    this.msg.lang = 'en' // 使用的语言
    this.msg.volume = 1 // 声音音量：1
    this.msg.rate = 1 // 语速：1
    this.msg.pitch = 1 // 音高：1
    this.synth.speak(this.msg) // 播放
  }
  // 中文语音
  private zhHandleSpeak(text) {
    this.msg.text = text // 文字内容
    this.msg.lang = 'zh-CN' // 使用的语言
    this.msg.volume = 1 // 声音音量：1
    this.msg.rate = 1 // 语速：1
    this.msg.pitch = 1 // 音高：1
    this.synth.speak(this.msg) // 播放
  }

  created() {
    if (!this.timer) {
      this.timer = setInterval(() => {
        this.getTaskCenter()
      }, 10 * 1000)
    }
    this.getEnterpriseInfo()
  }

  destroyed() {
    if (this.timer !== null) {
      clearInterval(this.timer)
    }
  }

  get sidebar() {
    return AppModule.sidebar
  }

  get routes() {
    return PermissionModule.routes
  }

  get showLogo() {
    return SettingsModule.showSidebarLogo
  }

  get menuActiveTextColor() {
    if (SettingsModule.sidebarTextTheme) {
      return SettingsModule.theme
    } else {
      return variables.menuActiveText
    }
  }

  get variables() {
    return variables
  }

  get activeMenu() {
    const route = this.$route
    const { meta, path } = route
    // if set path, the sidebar will highlight the path you set
    if (meta!.activeMenu) {
      return meta!.activeMenu
    }
    return path
  }

  get isCollapse() {
    return !this.sidebar.opened
  }
}
